import { uid } from "@dhx/ts-common/core";
import { IEventSystem } from "@dhx/ts-common/events";
import { DataCallback, DataEvents, Id, IDataItem, TreeCollection, DataDriver, toDataDriver } from "@dhx/ts-data";
import { TreeGridEvents } from "./types";
export class TreeGridCollection extends TreeCollection {
	constructor(config?: any, events?: IEventSystem<DataEvents | TreeGridEvents>) {
		super(config, events);
	}
	eachChild(id: Id, cb: any, direct: boolean = true, checkItem?: (item: IDataItem) => boolean) {
		checkItem = checkItem || (item => item.$opened !== false);
		super.eachChild(id, cb, direct, checkItem);
	}
	getMaxLevel(): number {
		let maxLevel = 1;
		this.map(el => {
			const level = this.getLevel(el.id);
			maxLevel = Math.max(level, maxLevel);
		});
		return maxLevel;
	}
	getLevel(id: string): number {
		let level = 0;
		this.eachParent(id, () => {
			level++;
		});
		return level;
	}
	serialize(driver: DataDriver = DataDriver.json): any[] {
		const data = [];
		this.eachChild(this.getRoot(), el => {
			if (!el) {
				return;
			}
			const cell = {
				...el,
				$level: this.getLevel(el.id),
				$items: this.haveItems(el.id)
			} as any;

			if (this.haveItems(el.id) && el.$opened === undefined) {
				el.$opened = cell.$opened = true;
			}
			data.push(cell);
		});
		const dataDriver = toDataDriver(driver);
		if (dataDriver) {
			return dataDriver.serialize(data);
		}
	}
	getPlainIndex(id: string): number {
		return Object.keys(this._pull).indexOf(id);
	}
	map(cb: DataCallback<IDataItem>, parent: Id = this._root, direct: boolean = true): any[] {
		let result: any[] = [];
		if (!this.haveItems(parent)) {
			return result;
		}
		for (let i = 0;i < this._childs[parent].length;i++) {
			result.push(cb.call(this, this._childs[parent][i], i));
			if (direct) {
				if (this._childs[parent][i].$opened) {
					const childResult = this.map(cb, this._childs[parent][i].id, direct);
					result = result.concat(childResult);
				}
			}
		}
		return result;
	}
	// [todo]
	getId(index: number) {
		return Object.keys(this._pull)[index];
	}
	protected _parse_data(data: any, parent = this._root) {
		for (let obj of data) {
			if (this.config.init) {
				obj = this.config.init(obj);
			}
			obj.id = obj.id ? obj.id.toString() : uid();
			obj.parent = obj.parent ? obj.parent.toString() : parent;

			this._pull[obj.id] = obj;

			if (!this._childs[obj.parent]) {
				this._childs[obj.parent] = [];
			}
			this._childs[obj.parent].push(obj);
			obj.$level = this.getLevel(obj.id);

			if (obj.items && obj.items instanceof Object) {
				obj.$opened = true;
				this._parse_data(obj.items, obj.id);
			}
		}
		this._checkItems();
	}
	private _checkItems() {
		this.eachChild(this._root, item => {
			item.$items = item.$opened = this.haveItems(item.id);
		});
	}
}